import { render, staticRenderFns } from "./FormAlert.vue?vue&type=template&id=6085c870&scoped=true&"
import script from "./FormAlert.vue?vue&type=script&lang=js&"
export * from "./FormAlert.vue?vue&type=script&lang=js&"
import style0 from "./FormAlert.vue?vue&type=style&index=0&id=6085c870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085c870",
  null
  
)

export default component.exports